import ConstraintResource from "../ConstraintResource.js";
import { Permission, Role } from "../Permissions.js";
import { useResourceStore } from "../../stores/resourceStore.js";

export default class UserResource extends ConstraintResource {
    /**
     * @param {string|Role} role
     * @param {any} options
     * @returns {boolean}
     */
    hasRole(role, options) {

        if (!role instanceof Role && typeof role !== 'string') {
            // console.error('Érvénytelen szerepkör argumentum', role);
            return false;
        }

        if (!this.data?.roles) {
            // console.error('Nem található szerepkör a felhasználó adataiban!');
            return false;
        }

        // console.info('Szerepkör ellenőrzése:', role);
        // console.info('Felhasználó adatainak szerepkörei:', this.data?.roles);

        return this.resolve(role, this.data.roles, options);
        // Megjegyzés (backend kompatibilitás):
        // Jelenleg a roles lista a `data.roles` alatt érkezik (legacy UserResource).
        // Ha átállunk a Farkas Balázs-féle backend implementációra, akkor a roles a
        // `relations.roles` alatt jön, és ezt a sort arra kell cserélni:
        // return this.resolve(role, this.relations.roles, options);
        // Megjegyzés:❗
        // Takács Bálint megjegyzése: a funkció jelenleg nincs ❗ℹ️ aktív használatban,
        // azonban a jövőbeni integrációhoz előkészítve maradt a rendszerben.
    }

    /**
     * @param {string|Permission} permission
     * @param {any} options
     * @returns {boolean}
     */
    hasPermission(permission, options) {

        if (!permission instanceof Permission && typeof permission !== 'string') {
            // console.error('Érvénytelen jogosultság argumentum', permission);
            return false;
        }

        if (!this.data?.permissions) {
            // console.error('Nem található jogosultság a felhasználó adataiban!');
            return false;
        }

        // console.info('Jogosultság ellenőrzése:', permission);
        // console.info('Felhasználó adatainak jogosultságai:', this.data?.permissions);

        return this.resolve(permission, this.data.permissions, options);
        // Megjegyzés (backend kompatibilitás):
        // Jelenleg a permissions lista a `data.permissions` alatt érkezik (legacy UserResource).
        // Farkas Balázs-féle backend UserResource esetén a permissions a `relations.permissions` alatt jön:
        // return this.resolve(permission, this.relations.permissions, options);
        // Megjegyzés:❗
        // Takács Bálint megjegyzése: a funkció jelenleg nincs ❗ℹ️ aktív használatban,
        // azonban a jövőbeni integrációhoz előkészítve maradt a rendszerben.

    }

    resolve(source, category, options) {
        if (!category) {
            // console.error('Nem lehet feloldani a felhasználói jogosultságokat "category" nélkül! Helyesen lett betöltve?');
            return false;
        }

        switch (typeof source) {
            case 'string':
                return this.resolveGluedString(source, category, options);
            case 'function':
                return this.resolveCallback(source, options);
            default: // object
                if (source instanceof Role || source instanceof Permission) {
                    return this.resolve(source.toString(), category, options);
                }

                let resolved = false;

                Object.keys(source).forEach((key) => { // Array
                    if (resolved) {
                        return;
                    }

                    let value = source[key];

                    resolved = this.resolve(value, category, options);
                });

                return resolved;

        }
    }

    resolveCallback(source, options) {
        return source(this.exposed, options);
    }

    resolveGluedString(source, category, options) {

        if (options?.hasOwnProperty('route')) {
            if (options.route.hasOwnProperty('to')) {
                for (let key in options.route.to.params) {
                    source = source.replace(`{${key}}`, options.route.to.params[key]);
                }
            }
        }

        // console.info('Feloldás string alapján:', source);

        source = source.indexOf(':') !== -1 ?
            source.split(':') :
            [0, source];

        return category[source[0]]?.includes(source[1]) ?? false;

    }

    isLoggedIn() {
        const resourceStore = useResourceStore();

        if (!resourceStore.getCurrentUser()?.data.uuid) {
            // console.error('Felhasználói adat vagy UUID hiányzik a resourceStore-ban.');
            return false;
        }

        if ((resourceStore.getCurrentUser()?.data.uuid ?? false) === this.data.uuid) {
            // console.info('A felhasználó be van jelentkezve:', resourceStore.getCurrentUser()?.data.uuid);
            return true;
        }

        return false; // TODO: Ellenőrzés a szerveren keresztül
    }
}